import Backbone from 'backbone'
import _ from 'lodash'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import appDisplay from 'scoreboard/components/app-display'
import DependenciesPreventActionView from 'scoreboard/components/edit/dependencies-prevent-action-view'
const { createBackboneErrorHandler } = DependenciesPreventActionView
import StrongConfirmPrompt from 'scoreboard/components/strong-confirm-prompt'

function deleteDomainObject(viewOrModel) {
	if (!viewOrModel) return
	var view = viewOrModel.render ? viewOrModel : null
	var model = viewOrModel.model ||  viewOrModel

	var context = _.cloneDeep(model.attributes)
	if (_.has(viewOrModel.options, 'confirmDeleteMessage')) {
		_.extend(context, {message: viewOrModel.options.confirmDeleteMessage})
	}
	if (_.get(viewOrModel.options, 'alertNotificationPrompt.delete')) {
		_.extend(context, {showNotificationPrompt: true})
	}
	if (_.get(viewOrModel.options, 'strongDeleteMessage')) {
		_.extend(context, {strongDeleteMessage: viewOrModel.options.strongDeleteMessage})
	}
	if (_.get(viewOrModel.options, 'deleteExtraBannerMessage')) {
		_.extend(context, {extraBannerMessage: viewOrModel.options.deleteExtraBannerMessage})
	}

	var confirmation = new DeleteConfirmation(context)

	// #13916 use a stronger delete confirmation if specified
	if (context.strongDeleteMessage) {
		confirmation = new StrongConfirmPrompt({
			label: context.label,
			message: context.strongDeleteMessage
		})
	}

	appDisplay.dialog(confirmation)
	confirmation.once('confirm', function() {
		view && view.trigger('delete')
		const sendNotification = confirmation.$('input[name=sendNotification]').prop('checked')
		const data = sendNotification && JSON.stringify({sendNotification})
		model.destroy({
			data,
			success: function(_, resp) {
				Backbone.trigger('delete:domain-object', model)
				confirmation.trigger('done', resp)
			},
			error: function(model, xhr) {
				// #31389 Reset the delete button on the form so it doesn't look
				// like it is stuck
				if (confirmation.formView) {
					confirmation.formView.resetForm({ instadone: true })
				}
				createBackboneErrorHandler()(model, xhr)
			}
		})
	})
	return confirmation
}

export default deleteDomainObject

deleteDomainObject.__filename__ = 'components/edit/delete-domain-object.js'
